import { render, staticRenderFns } from "./user-leave.vue?vue&type=template&id=1731d154&scoped=true&"
import script from "./user-leave.vue?vue&type=script&lang=ts&"
export * from "./user-leave.vue?vue&type=script&lang=ts&"
import style0 from "./user-leave.vue?vue&type=style&index=0&id=1731d154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1731d154",
  null
  
)

export default component.exports